// 组件对象，大写
import imageEditor from './imageEditor.vue'
export default imageEditor
